import enGB from './en-gb.json'
import frFR from './fr-fr.json'
import deDE from './de-de.json'
import itIT from './it-it.json'

export default { 'en-ch': enGB, 'fr-ch': frFR, 'de-ch': deDE, 'it-ch': itIT }
